import { Component, EventEmitter, inject } from '@angular/core';
import { BaseContainer } from 'app/modules/base/BaseContainer';
import { fadeInAnimation } from '../../../animations';
import { ScrollService } from '../../../core/services/scroll.service';
import { InvoiceSandbox } from '../../../core/sandboxes/invoice.sandbox';
import { Button, Paging } from '@dlw-int-mwi/eps-common';
import { firstValueFrom } from 'rxjs';
import { appSettings } from '../../../appSettings';
import { InvoiceQueryFilter, InvoiceQueryRequest, InvoiceQueryResponseRecord } from '../../../core/interfaces/invoice.interface';
import { NotificationService } from '../../../core/services/notification.service';

@Component({
  selector: 'invoices-page-container',
  templateUrl: './invoices-page-container.component.html',
  styleUrls: ['./invoices-page-container.component.scss'],
  animations: [fadeInAnimation],
})
export class InvoicesPageContainer extends BaseContainer {
  invoices: InvoiceQueryResponseRecord[] = null;
  loading = false;
  sandbox = inject(InvoiceSandbox);
  private scrollService = inject(ScrollService);
  private notificationService = inject(NotificationService);
  downloadExcelListButton: Button[] = [{ label: 'Excel', type: 'default', icon: 'download', click: () => this.downloadExcelList(), disabled$: this.sandbox.busy$ }];
  clearFilter = new EventEmitter<void>();
  dateFormat: string = appSettings.DATE_FORMAT_ANGULAR;

  filter: InvoiceQueryFilter = undefined;
  paging: Paging = {
    itemsPerPage: 25, page: 0, sortKey: 'invoiceDate', sortOrder: 'DESC', totalCount: 0
  };
  filterValid = false;

  get filterRequest(): InvoiceQueryRequest {
    return {
      ...this.filter,
      pageNumber: this.paging.page,
      pageSize: this.paging.itemsPerPage,
      sortingColumn: this.paging.sortKey,
      sortingType: this.paging.sortOrder,
    }
  }

  constructor() {
    super();
  }

  async filterInvoices(paging: any) {
    if (await firstValueFrom(this.sandbox.busy$)) {
      return;
    }
    this.loading = true;
    this.paging = paging;
    try {
      const result = await firstValueFrom(this.sandbox.getInvoices(this.filterRequest));
      this.invoices = result.items;
      this.paging.totalCount = result.totalItems;
    } catch (e) {
      console.error(e);
      this.notificationService.showToastr({
        message: 'Unable to execute query',
        type: 'error'
      });
    } finally {
      this.loading = false;
      this.cd.markForCheck();
    }
  }

  downloadExcelList(): void {
    this.sandbox.downloadList(this.filter);
  }

  setFilter({ filter, valid }: { filter: InvoiceQueryFilter, valid: boolean }) {
    this.filterValid = valid;
    this.filter = filter;
  }

  async openInvoice(invoice: InvoiceQueryResponseRecord) {
    this.sandbox.downloadInvoice({
      invoiceNumber: invoice.invoiceNumber,
      source: invoice.source,
      invoiceDate: invoice.invoiceDate,
      soldToId: invoice.soldToId,
      eSoftId: invoice.eSoftId,
    });
  }

  onClearFilter(): void {
    this.clearFilter.emit();

    this.invoices = null;
    this.paging.page = 0;
    this.paging.totalCount = 0;
  }
}
